import { apiClient } from './client';
import { API_CONFIG } from './config';

export type ShortUrlEntity = {
  shortUrlId: string;
  projectId: string;
  refId: string;
  code: string;
  type: string;
  metadata?: unknown;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  expiredAt: string | null;
};

/** The short-url controller wraps every payload in `{ data }`. */
type Envelope<T> = { data: T };

class ShortUrlApi {
  private ep = API_CONFIG.endpoints.shortUrl;

  /** Public: resolves a code, or `{ data: null }` once the link has expired. */
  getByCode(code: string) {
    return apiClient.get<Envelope<ShortUrlEntity | null>>(this.ep.byCode(code));
  }

  /** Mints a new code for the user, replacing any link issued earlier. */
  resetPassword(userId: string) {
    return apiClient.post<Envelope<ShortUrlEntity>>(this.ep.resetPassword(userId), {});
  }

  /**
   * Burns a link so it cannot be replayed. The endpoint is authenticated, so the
   * reset flow passes the token it just received instead of the stored session.
   */
  expire(code: string, token?: string) {
    return apiClient.patch(
      this.ep.expire(code),
      {},
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
    );
  }
}

export const shortUrlApi = new ShortUrlApi();
